import { render, staticRenderFns } from "./SatgasMonitorVendor.vue?vue&type=template&id=560c6961"
import script from "./SatgasMonitorVendor.vue?vue&type=script&lang=js"
export * from "./SatgasMonitorVendor.vue?vue&type=script&lang=js"
import style0 from "./SatgasMonitorVendor.vue?vue&type=style&index=0&id=560c6961&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports